import { Stack, styled } from '@mui/material';
import { useGetGiftContributorRecipients } from '@portal-middleware/hooks';
import { useGetSessionInfo } from '@sentinel/hooks';

import { FC, useMemo } from 'react';

import RecipientsLink from './RecipientLink';

const SideScrollingStack = styled(Stack)(({ theme }) => ({
  '& > *': {
    flex: '0 0 auto'
  },
  '&::-webkit-scrollbar': {
    display: 'none'
  },
  '-ms-overflow-style': 'none',
  overflowX: 'auto',
  padding: theme.spacing(2),
  scrollBehavior: 'smooth',
  scrollbarWidth: 'none',
  width: '100%'
}));

const RecipientsList: FC = () => {
  const user = useGetSessionInfo('user', {
    query: {
      suspense: true
    }
  });

  const recipients = useGetGiftContributorRecipients(
    user?.data?.giftContributorId,
    {
      query: {
        suspense: true
      }
    }
  );

  const hideRecipients = useMemo(() => {
    return recipients?.data?.data?.length <= 1 ? 'none' : 'flex';
  }, [recipients]);

  return (
    <SideScrollingStack
      direction={{ md: 'column', sm: 'row', xs: 'row' }}
      display={{
        md: 'flex',
        sm: hideRecipients,
        xs: hideRecipients
      }}
      gap={4}>
      {recipients?.data?.data?.map(recipient => {
        return <RecipientsLink giftRecipient={recipient} key={recipient.id} />;
      })}
    </SideScrollingStack>
  );
};

export default RecipientsList;
